import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../common/u1/Button";
import { SearchIcon, InfoIcon } from "../../../../assets/ui/icons";

/* Empty result state. `orderWebProfileState` is the pre-fill payload forwarded to /order-web-profile — the same { prefill: { companyName, countryCode } }... */
export const SearchEmptyState = ({
  heading,
  query,
  orderWebProfileState,
  listBusinessTo = "/sign-up",
  listBusinessState = { redirectToStep: 6 },
}) => (
  <div className="rounded-xl border-[1.5px] border-dashed border-[var(--line-2)] bg-white px-6 py-9 text-center">
    <div className="w-14 h-14 rounded-[14px] bg-[var(--orange-soft)] text-[var(--orange)] inline-flex items-center justify-center mb-3.5">
      <SearchIcon />
    </div>
    <h3 className="text-[20px] font-bold text-[var(--ink)] font-sans mb-2">
      {heading || `No businesses match ${query ? `"${query}"` : "your search"}.`}
    </h3>
    <p className="text-[13px] text-[var(--muted)] max-w-[460px] mx-auto mb-[18px] leading-[1.5] font-sans">
      Try a different spelling, or order a Web Profile if you know the business and it is not yet
      on TREVEX.
    </p>
    <div className="flex gap-2.5 justify-center flex-wrap">
      <Link to={listBusinessTo} state={listBusinessState}>
        <Button variant="primary">List your business. It is free.</Button>
      </Link>
      <Link to="/order-web-profile" state={orderWebProfileState}>
        <Button variant="outline">Order a web profile</Button>
      </Link>
    </div>
  </div>
);

/* Advisory / degraded-search banner. */
export const SearchNotice = ({ tone = "warning", children, orderWebProfileState, showActions = false }) => {
  const toneClasses =
    tone === "error"
      ? "bg-[var(--orange-soft)] border-[var(--orange-border)] text-[var(--ink-2)]"
      : "bg-[var(--warning-soft)] border-[var(--warning)] text-[var(--ink-2)]";
  const iconColour = tone === "error" ? "text-[var(--orange)]" : "text-[var(--warning)]";

  return (
    <div className={`mt-3.5 rounded-xl border px-4 py-3.5 flex gap-3 items-start ${toneClasses}`}>
      <span className={`${iconColour} shrink-0 flex mt-px`}>
        <InfoIcon />
      </span>
      <div className="text-[13px] leading-[1.5] font-sans">
        {children}
        {showActions && (
          <span>
            {" "}You can{" "}
            <Link
              className="underline font-bold text-[var(--navy)]"
              to="/sign-up"
              state={{ redirectToStep: 6 }}
            >
              claim your business profile
            </Link>{" "}
            or{" "}
            <Link
              className="underline font-bold text-[var(--navy)]"
              to="/order-web-profile"
              state={orderWebProfileState}
            >
              order a web profile
            </Link>
            .
          </span>
        )}
      </div>
    </div>
  );
};

export default SearchEmptyState;
